import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { FiGrid, FiList } from 'react-icons/fi';
import FileIcon from './FileIcon';
import './RecentActivityCard.css';

const RecentActivity = () => {
  const [activities, setActivities] = useState([]);
  const [viewMode, setViewMode] = useState('grid');

  useEffect(() => {
    fetchRecentActivities();
  }, []);

  const fetchRecentActivities = async () => {
    const token = localStorage.getItem("token");
    if (!token) return;

    try {
      const response = await axios.get('/api/activity/recent', {
        headers: { Authorization: `Bearer ${token}` }
      });

      const data = Array.isArray(response.data.activities)
        ? response.data.activities.slice(0, 10)
        : [];

      setActivities(data);
    } catch (error) {
      console.error('Erro ao buscar atividades recentes:', error);
    }
  };

  const formatDescription = (desc) => {
    if (desc.includes('concluído') || desc.includes('iniciado')) {
      const fileMatch = desc.match(/"(.*)"/);
      return fileMatch ? fileMatch[1] : desc;
    }
    return desc;
  };

  const formatTimestamp = (ts) => {
    const date = new Date(ts);
    date.setHours(date.getHours() - 3);
    return date.toLocaleString("pt-BR");
  };

  return (
    <div className="recent-activity-container bg-white shadow-sm rounded p-3">
      <div className="recent-activity-header d-flex align-items-center justify-content-between mb-3">
        <span className="fw-bold fs-6">Atividade recente</span>
        <div className="toggle-view">
          <FiGrid
            size={20}
            className={viewMode === 'grid' ? 'active' : ''}
            onClick={() => setViewMode('grid')}
          />
          <FiList
            size={20}
            className={viewMode === 'list' ? 'active' : ''}
            onClick={() => setViewMode('list')}
          />
        </div>
      </div>

      {viewMode === 'grid' ? (
        <div className="grid-view">
          {activities.map((activity) => (
            <div key={activity.id} className="grid-item card p-2 shadow-sm">
              <div className="text-center mb-1">
                <FileIcon extension={formatDescription(activity.description).split('.').pop()} />
              </div>
              <div className="file-name text-center small">
                {formatDescription(activity.description)}
              </div>
              <div className="file-time text-center text-muted small">
                [{activity.bucket_name}]<br />{formatTimestamp(activity.timestamp)}
              </div>
            </div>
          ))}
        </div>
      ) : (
        <div className="list-view">
          {activities.map((activity) => (
            <div key={activity.id} className="list-item card p-2 mb-2 shadow-sm d-flex align-items-center">
              <div className="me-2">
                <FileIcon extension={formatDescription(activity.description).split('.').pop()} />
              </div>
              <div className="file-details">
                <div className="file-name small fw-semibold">
                  Arquivo enviado: {formatDescription(activity.description)}
                </div>
                <div className="file-location text-muted small">
                  [{activity.bucket_name}] {formatTimestamp(activity.timestamp)}
                </div>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default RecentActivity;
